import Stopwatch from '@components/shared/Stopwatch/Stopwatch'

interface TopStatsBarProps {
  versesRead?: number
  onEditGoal?: () => void
  mode?: 'daily' | 'standalone'
}

const TopStatsBar = ({ versesRead, onEditGoal, mode = 'daily' }: TopStatsBarProps) => {
  return (
    <div className="flex items-center justify-between px-4 py-3 relative z-10">
      {/* Edit goal button */}
      {mode === 'daily' && onEditGoal ? (
        <button
          onClick={onEditGoal}
          className="text-main hover:text-brand-secondary transition-colors p-1"
          aria-label="Hedefi Düzenle"
        >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      </button>
      ) : (
        <div className="w-8" />
      )}

      {/* Stats pills */}
      <div className="flex items-center gap-2">
        {mode === 'daily' && versesRead !== undefined && (
          <span className="flex items-center gap-1 px-3 py-1 bg-surface-subtle border border-main rounded-full text-main text-[11px] font-bold shadow-sm">
            <span className="text-[10px]">📗</span> {versesRead}
          </span>
        )}

        {/* Stopwatch Pill */}
        <div className="flex items-center gap-1 px-2 py-0.5 bg-surface-subtle border border-main rounded-full text-main text-[11px] font-bold shadow-sm h-[26px]">
          <span className="text-[10px]">⏱</span>
          <Stopwatch
            getTime={() => {}}
            width="auto"
            className="border-none! bg-transparent! p-0! h-auto! text-main! text-[11px]! hover:bg-transparent! focus-visible:ring-0! shadow-none!"
          />
        </div>
      </div>

      {/* Placeholder for settings */}
      <div className="w-6" />
    </div>
  )
}

export default TopStatsBar
